import { writable, readable } from 'svelte/store';

export const debug = readable(false);
export const user = writable(null);
export const readonly = writable(true);
export const queries = writable([]);
export const queryResults = writable({});
export const history = writable([]);
export const macroHistory = writable([]);
export const tags = writable([]);
export const search = writable("");